'use client';
import { forwardRef } from 'react';
import { Box, css, getColorByToken } from '@wanteddev/wds-engine';
import { createResponsiveStyle, getPreviousValue } from '../../utils/responsive-props.mjs';
import { typographyStyle, ellipsisTypographyStyle } from '../../utils/typography.mjs';
import { jsx } from 'react/jsx-runtime';

var Typography = forwardRef(
  ({
    as,
    variant = "body1_normal",
    weight = "regular",
    noWrap = false,
    display = "inline",
    align = "left",
    color,
    sx,
    xs,
    sm,
    md,
    lg,
    xl,
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsx(
      Box,
      {
        as: as || "span",
        ref,
        sx: [
          (theme) => css`
            ${typographyStyle(variant, weight)}
            ${noWrap && ellipsisTypographyStyle(1)}
            ${Boolean(align) && css`
              text-align: ${align};
            `}
            ${Boolean(display) && css`
              display: ${display};
            `}
            ${Boolean(color) ? css`
                  color: ${getColorByToken(theme, color)};
                ` : css`
                  color: inherit;
                `}

            ${createResponsiveStyle(
            { xs, sm, md, lg, xl },
            theme
          )(
            (params, breakpoint) => css`
                ${(Boolean(params?.variant) || Boolean(params?.weight)) && typographyStyle(
              getPreviousValue(
                { xs, sm, md, lg, xl },
                "variant",
                variant,
                breakpoint
              ),
              getPreviousValue(
                { xs, sm, md, lg, xl },
                "weight",
                weight,
                breakpoint
              )
            )}

                ${Boolean(params?.align) && css`
                  text-align: ${params?.align};
                `}
                
                ${params?.sx}
              `
          )};
          `,
          sx
        ],
        ...props
      }
    );
  }
);
Typography.displayName = "Typography";
var typography_default = Typography;

export { typography_default as default };
